<template>
  <timeline-item
    :type="type"
    :title="title"
    :date="date"
    :by-name="byName"
    icon="task"
    color="is-activities"
  ></timeline-item>
</template>

<script>
import TimelineItem from "./TimelineItem";
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "TimelineTask",
  components: {TimelineItem},
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    type() {
      let action = '';
      const status = this.task.new_value.status;

      switch (this.task.action) {
        case ENUMS.ActivityActionEnum.Initial.value:
          action = 'Created';
          break;
        case ENUMS.ActivityActionEnum.Changed.value:
          if(status === ENUMS.TaskStatusEnum.Ignored.value) {
            action = 'Unchecked'
          }
          else if(status === ENUMS.TaskStatusEnum.Incomplete.value) {
            action = 'Crossed Out'
          }
          else if(status === ENUMS.TaskStatusEnum.Complete.value) {
            action = 'Completed'
          }
          else {
            action = 'Edited'
          }
          break;
        case ENUMS.ActivityActionEnum.Deleted.value:
          action = 'Deleted';
          break;
        default:
          action = '';
      }

      return 'Task ' + action;
    },
    title() {
      return this.task.new_value.label;
    },
    date() {
      return dates.formatAsDateTime(this.task.created_at);
    },
    byName() {
      return this.task.createdBy.display_name;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
